import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { isRequired } from 'components/Questionnaires/validators';
import BoxInputField from 'components/Common/Inputs/BoxInputField';

export const QuestionSocialInsuranceNumberField = ({ intl, blockId, question, className, disabled, onChange }) => {
  const [inputValue, setInputValue] = useState(question?.answer ?? question.default ?? '');

  const onInputChange = (value) => {
    setInputValue(value);
    if (inputValue !== value) {
      onChange(question, value);
    }
    return true;
  };

  const getBoxClass = () => {
    if (question.isValid === false) {
      return ' error';
    }
    return '';
  };

  return (<div id={ question.id }>
    <BoxInputField
      key={ `${ blockId }-${ question.id }` }
      id={ `${ blockId }-${ question.id }` }
      name={ question.id }
      className={ `tin-box ${ className } ${ getBoxClass() }` }
      disabled={ disabled }
      initialValue={ inputValue }
      callback={ onInputChange }
      fieldLength={ 9 }
      answerRequired={ isRequired(question) }
      describedby={ `${ question.isValid === false ? (`${ blockId }-${ question.id }-error`) : '' }` }
    />
  </div>);
};

QuestionSocialInsuranceNumberField.displayName = 'QuestionUsTinField';

QuestionSocialInsuranceNumberField.propTypes = {
  blockId: PropTypes.string.isRequired,
  question: PropTypes.shape().isRequired,
  intl: PropTypes.shape().isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

QuestionSocialInsuranceNumberField.defaultProps = {
  className: '',
  disabled: false,
};

export default QuestionSocialInsuranceNumberField;
